import {
  FETCH_FILTERS_START,
  FETCH_FILTERS_SUCCESS,
  FETCH_FILTERS_FAIL,
  CREATE_FILTER_START,
  CREATE_FILTER_SUCCESS,
  CREATE_FILTER_FAIL,
  DELETE_FILTER_START,
  DELETE_FILTER_SUCCESS,
  DELETE_FILTER_FAIL,
  FETCH_FILTER_ITEM_START,
  FETCH_FILTER_ITEM_SUCCESS,
  FETCH_FILTER_ITEM_FAIL,
  UPDATE_FILTER_START,
  UPDATE_FILTER_SUCCESS,
  UPDATE_FILTER_FAIL,
  ADD_FILTER_ITEMS_SUCCESS,
  REMOVE_FILTER_ITEM_SUCCESS,
  UPDATE_FILTER_ITEM_POSITION_SUCCESS,
  REPLACE_FILTER_ATTRIBUTE_ITEMS_SUCCESS,
  UPSERT_FILTER_ATTRIBUTE_CONFIG_SUCCESS,
  DELETE_FILTER_ATTRIBUTE_CONFIG_SUCCESS,
  ADD_FILTER_CUSTOM_ITEM_SUCCESS,
  UPDATE_FILTER_CUSTOM_ITEM_SUCCESS,
  DELETE_FILTER_CUSTOM_ITEM_SUCCESS,
  UPDATE_POSITION_FILTER_CUSTOM_ITEM_SUCCESS,
  UPDATE_FILTERS_POSITIONS,
} from './action';

/**
 * Начальное состояние reducer'а filters.
 * Содержит список filters, текущий открытый фильтр (filter), и набор флагов загрузки.
 */
const initialState = {
  filters: undefined,
  filter: undefined,
  mixedItems: undefined,
  loadingFiltersErr: null,
  createErr: null,
  deleteErr: null,
  updateErr: null,
  loadingFilterErr: null,
  isLoading: false,
  isCreating: false,
  isDeleting: false,
  isUpdating: false,
  isFilterLoading: false,
  isInitial: false,
};

/**
 * Reducer для модуля Filters.
 * Хранит список фильтров (filters), текущий открытый (filter с filterItems и customItems)
 * и набор флагов loading/processing для UI.
 */
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case UPDATE_FILTERS_POSITIONS:
    return {
      ...state,
      mixedItems: payload,
    };
  case FETCH_FILTERS_START:
    return {
      ...state,
      isLoading: true,
    };
  case FETCH_FILTERS_SUCCESS: {
    return {
      ...state,
      filters: [...payload.data],
      isLoading: false,
      isInitial: true,
    };
  }
  case FETCH_FILTERS_FAIL:
    return {
      ...state,
      loadingFiltersErr: payload,
      isLoading: false,
      isInitial: true,
    };
  case CREATE_FILTER_START:
    return {
      ...state,
      isCreating: true,
    };
  case CREATE_FILTER_SUCCESS: {
    const existing = state.filters?.find((f) => f.id === payload.data.id);
    if (existing) {
      return { ...state, isCreating: false };
    }
    return {
      ...state,
      filters: [...(state.filters ?? []), payload.data],
      isCreating: false,
    };
  }
  case CREATE_FILTER_FAIL:
    return {
      ...state,
      createErr: payload,
      isCreating: false,
    };
  case DELETE_FILTER_START:
    return {
      ...state,
      isDeleting: true,
    };
  case DELETE_FILTER_SUCCESS: {
    return {
      ...state,
      filters: state.filters?.filter((item) => item.id !== payload),
      isDeleting: false,
    };
  }
  case DELETE_FILTER_FAIL:
    return {
      ...state,
      deleteErr: payload,
      isDeleting: false,
    };
  case FETCH_FILTER_ITEM_START:
    return {
      ...state,
      isFilterLoading: true,
    };
  case FETCH_FILTER_ITEM_SUCCESS: {
    return {
      ...state,
      filter: { ...payload.data },
      isFilterLoading: false,
      isInitial: true,
    };
  }
  case FETCH_FILTER_ITEM_FAIL:
    return {
      ...state,
      loadingFilterErr: payload,
      isFilterLoading: false,
      isInitial: true,
    };
  case UPDATE_FILTER_START:
    return {
      ...state,
      isUpdating: true,
    };
  case UPDATE_FILTER_SUCCESS: {
    // Обновляем поля в state.filter и в массиве state.filters.
    let filter = state.filter ?? null;
    if (filter && filter.id === payload.id) {
      filter = {
        ...filter,
        ...(payload.localizeInfos !== undefined ? { localizeInfos: payload.localizeInfos } : {}),
        ...(payload.identifier !== undefined ? { identifier: payload.identifier } : {}),
        ...(payload.scopeTypes !== undefined ? { scopeTypes: payload.scopeTypes } : {}),
      };
    }
    return {
      ...state,
      filter,
      filters: (state.filters ?? []).map((el) => {
        if (el.id === payload.id) {
          return {
            ...el,
            ...(payload.localizeInfos !== undefined ? { localizeInfos: payload.localizeInfos } : {}),
            ...(payload.identifier !== undefined ? { identifier: payload.identifier } : {}),
            ...(payload.scopeTypes !== undefined ? { scopeTypes: payload.scopeTypes } : {}),
          };
        }
        return el;
      }),
      isUpdating: false,
    };
  }
  case UPDATE_FILTER_FAIL:
    return {
      ...state,
      updateErr: payload,
      isUpdating: false,
    };
  case ADD_FILTER_ITEMS_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        filterItems: [...(state.filter.filterItems ?? []), ...payload.items],
      },
    };
  }
  case REMOVE_FILTER_ITEM_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        filterItems: (state.filter.filterItems ?? []).filter((it) => it.id !== payload.itemId),
      },
    };
  }
  case REPLACE_FILTER_ATTRIBUTE_ITEMS_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    // Удаляем все items текущей пары (attributeSetId + attributeIdentifier),
    // затем подкладываем новые. Это «грязный» вариант сохранения консистентности
    // с бэком: бэк уже выполнил атомарный DELETE+INSERT, фронт просто синхронизирует.
    const setId = Number(payload.attributeSetId);
    const attrIdentifier = payload.attributeIdentifier ?? '';
    const remaining = (state.filter.filterItems ?? []).filter((it) => {
      if (it.objectType !== 'attribute') {
        return true;
      }
      if (Number(it.objectId) !== setId) {
        return true;
      }
      if ((it.attributeIdentifier ?? '') !== attrIdentifier) {
        return true;
      }
      return false;
    });
    return {
      ...state,
      filter: {
        ...state.filter,
        filterItems: [...remaining, ...(payload.items ?? [])],
      },
    };
  }
  case UPSERT_FILTER_ATTRIBUTE_CONFIG_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    // Апсертим запись в filter.config.attribute из ответа бэка (актуальная
    // запись конфига: attributesSetsId / attributesId / isPinned / knownValues).
    // items НЕ трогаем — пин по требованию меняет только иконку, не выборку.
    const entry = payload.entry ?? null;
    if (!entry) {
      return { ...state };
    }
    const config = state.filter.config ?? {};
    const attribute = config.attribute ?? [];
    const idx = attribute.findIndex(
      (e) => Number(e.attributesSetsId) === Number(entry.attributesSetsId)
        && (e.attributesId ?? '') === (entry.attributesId ?? ''),
    );
    const nextAttribute = idx >= 0
      ? attribute.map((e, i) => (i === idx ? entry : e))
      : [...attribute, entry];
    return {
      ...state,
      filter: {
        ...state.filter,
        config: { ...config, attribute: nextAttribute },
      },
    };
  }
  case DELETE_FILTER_ATTRIBUTE_CONFIG_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    // Убираем запись пары из config.attribute. items не трогаем.
    const setId = Number(payload.attributeSetId);
    const attrIdentifier = payload.attributeIdentifier ?? '';
    const config = state.filter.config ?? {};
    const attribute = (config.attribute ?? []).filter(
      (e) => !(Number(e.attributesSetsId) === setId
        && (e.attributesId ?? '') === attrIdentifier),
    );
    return {
      ...state,
      filter: {
        ...state.filter,
        config: { ...config, attribute },
      },
    };
  }
  case UPDATE_FILTER_ITEM_POSITION_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        filterItems: (state.filter.filterItems ?? []).map((it) => {
          if (it.id === payload.itemId) {
            return { ...it, ...payload.item };
          }
          return it;
        }),
      },
    };
  }
  case ADD_FILTER_CUSTOM_ITEM_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        customItems: [...(state.filter.customItems ?? []), payload.item],
      },
    };
  }
  case UPDATE_FILTER_CUSTOM_ITEM_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        customItems: (state.filter.customItems ?? []).map((it) => {
          if (it.id === payload.itemId) {
            return { ...it, ...payload.item };
          }
          return it;
        }),
      },
    };
  }
  case DELETE_FILTER_CUSTOM_ITEM_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        customItems: (state.filter.customItems ?? []).filter((it) => it.id !== payload.itemId),
      },
    };
  }
  case UPDATE_POSITION_FILTER_CUSTOM_ITEM_SUCCESS: {
    if (!state.filter || state.filter.id !== payload.filterId) {
      return { ...state };
    }
    return {
      ...state,
      filter: {
        ...state.filter,
        customItems: (state.filter.customItems ?? []).map((it) => {
          if (it.id === payload.itemId) {
            return { ...it, ...payload.item };
          }
          return it;
        }),
      },
    };
  }
  default:
    return { ...state };
  }
};
